module.exports = __webpack_public_path__ + "static/media/coherence.0fd2a77a.svg";